import {
  SET_DOSSIERS,
  UPDATE_DOSSIER_STATUT,
  UPDATE_CONFIRMATION,
  SET_FILTERS,
  SET_CURRENT_DOSSIER,
  UPDATE_FORM_DATA,
  SET_CURRENT_RUBRIQUE,
  SET_CURRENT_PAGE,
  SET_PAGINATION,
  SET_DOSSIER_COMPLET, SET_DOSSIER_LOADING,
  API_PENDING_INC, API_PENDING_DEC
} from "./actions";
import axios from "axios";
const API_BASE = ((typeof window !== "undefined" && window.location && window.location.protocol === "https:") ? "https://portail-dossiers.technchange.net/services" : "http://57.128.30.4:7000/services");


// ─── Dossiers ────────────────────────────────────────────────────────────────

// Charge TOUS les dossiers (l'API plafonne limit à 100 → on boucle sur les pages)
// pour permettre un filtrage GLOBAL côté client. Aucune modification de l'API.
const fetchDossiers = () => async (dispatch) => {
  const PAGE_SIZE = 100; // plafond serveur observé
  let all = [];
  try {
    let page = 1, totalPages = 1;
    do {
      const res = await fetch(
        `${API_BASE}/api/dossiers?page=${page}&limit=${PAGE_SIZE}`,
        { headers: { "ngrok-skip-browser-warning": "true" } },
      );
      const json = await res.json();
      if (!json || !json.success) break;
      all = all.concat(json.data || []);
      totalPages = (json.pagination && json.pagination.total_pages) || 1;
      page += 1;
    } while (page <= totalPages);
  } catch (err) {
    console.error("Erreur fetchDossiers:", err);
  } finally {
    // On dispatch même en cas d'échec/partiel : ne pas jeter les dossiers déjà récupérés
    const normalized = all.map((d) => ({
      id:                d.id_dossier,
      numero_dossier:    d.numero_dossier,
      patient:           d.patient,
      service:           d.service,
      date_upload:       d.date_upload,
      heure:             d.heure,
      statut:            d.statut === "Traité" ? "traite" : "non_traite",
      etat_confirmation: d.confirmation,
    }));
    dispatch({ type: SET_DOSSIERS, payload: normalized });
    dispatch({ type: SET_PAGINATION, payload: { page: 1, limit: normalized.length, total: normalized.length, total_pages: 1 } });
  }
};

const updateStatut = (id, statut) => (dispatch) => {
  dispatch({ type: UPDATE_DOSSIER_STATUT, payload: { id, statut } });
};

const updateConfirmation = (id) => async (dispatch) => {
  dispatch({ type: API_PENDING_INC });
  try {
    const res = await fetch(`${API_BASE}/api/dossiers/${id}/confirmation`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    const json = await res.json();
    if (json.success) {
      dispatch({
        type: UPDATE_CONFIRMATION,
        payload: { id, etat_confirmation: json.data.confirmation },
      });
      return { success: true, confirmation: json.data.confirmation };
    }
    return { success: false };
  } catch (err) {
    console.error("Erreur updateConfirmation:", err);
    return { success: false };
  } finally {
    dispatch({ type: API_PENDING_DEC });
  }
};

const setFilters = (filters) => (dispatch) => {
  dispatch({ type: SET_FILTERS, payload: filters });
};

const setCurrentDossier = (dossier) => (dispatch) => {
  dispatch({ type: SET_CURRENT_DOSSIER, payload: dossier });
};

// ─── Formulaires ─────────────────────────────────────────────────────────────

const setCurrentRubrique = (index) => (dispatch) => {
  dispatch({ type: SET_CURRENT_RUBRIQUE, payload: index });
};

const setCurrentPage = (index) => (dispatch) => {
  dispatch({ type: SET_CURRENT_PAGE, payload: index });
};

const updateFormData = (dossierId, rubrique, sousRubrique, values) => (dispatch) => {
  dispatch({
    type: UPDATE_FORM_DATA,
    payload: { dossierId, rubrique, sousRubrique, values },
  });
};

const fetchDossierComplet = (id) => async (dispatch) => {
  dispatch({ type: SET_DOSSIER_LOADING, payload: true });
  dispatch({ type: API_PENDING_INC });
  try {
    const res = await fetch(`${API_BASE}/api/dossiers/${id}/complete`);
    const json = await res.json();
    if (json.success || json.data) {
      dispatch({ type: SET_DOSSIER_COMPLET, payload: { id, data: json.data, source: json._source } });
    }
  } catch (err) {
    console.error("Erreur fetchDossierComplet :", err);
  } finally {
    dispatch({ type: SET_DOSSIER_LOADING, payload: false });
    dispatch({ type: API_PENDING_DEC });
  }
};

export const saveDossier = () => async (dispatch, getState) => {
  const state = getState();
  const currentDossier = state.dossiers.currentDossier;

  const response = await axios.post(
    ((typeof window !== "undefined" && window.location && window.location.protocol === "https:") ? "https://portail-dossiers.technchange.net/mongo" : "http://57.128.30.4:7000/mongo") + "/api/dossiers",
    {
      id_dossier: currentDossier.id,
      numero_dossier: currentDossier.numero_dossier.replace("/", "_"),
      data: state.formulaires.data[currentDossier.id],
    },
  );

  return response.data;
};

export {
  fetchDossiers,
  updateStatut,
  updateConfirmation,
  setFilters,
  setCurrentDossier,
  setCurrentRubrique,
  setCurrentPage,
  updateFormData,
  fetchDossierComplet
};